import styled from 'styled-components';
import { Heading } from '@lendi-ui/typography';
// @ts-ignore
export const BoldHeading = styled(Heading)`
  font-weight: bold;
`;
